import Home from './containers/home';

function App() {
  return (
    <Home />
  );
}

export default App;
